var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-plus-icon",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"el-icon-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }